import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateSelfReturnCodesMutationVariables = Types.Exact<{
  amount: Types.Scalars['Int'];
}>;


export type CreateSelfReturnCodesMutation = { __typename?: 'Mutation', createSelfReturnCodes: Array<{ __typename?: 'SelfReturnCode', id: string, is_valid: boolean, trackable_item_id?: string | null }> };


export const CreateSelfReturnCodesDocument = gql`
    mutation CreateSelfReturnCodes($amount: Int!) {
  createSelfReturnCodes(amount: $amount) {
    id
    is_valid
    trackable_item_id
  }
}
    `;
export type CreateSelfReturnCodesMutationFn = Apollo.MutationFunction<CreateSelfReturnCodesMutation, CreateSelfReturnCodesMutationVariables>;

/**
 * __useCreateSelfReturnCodesMutation__
 *
 * To run a mutation, you first call `useCreateSelfReturnCodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSelfReturnCodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSelfReturnCodesMutation, { data, loading, error }] = useCreateSelfReturnCodesMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useCreateSelfReturnCodesMutation(baseOptions?: Apollo.MutationHookOptions<CreateSelfReturnCodesMutation, CreateSelfReturnCodesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSelfReturnCodesMutation, CreateSelfReturnCodesMutationVariables>(CreateSelfReturnCodesDocument, options);
      }
export type CreateSelfReturnCodesMutationHookResult = ReturnType<typeof useCreateSelfReturnCodesMutation>;
export type CreateSelfReturnCodesMutationResult = Apollo.MutationResult<CreateSelfReturnCodesMutation>;
export type CreateSelfReturnCodesMutationOptions = Apollo.BaseMutationOptions<CreateSelfReturnCodesMutation, CreateSelfReturnCodesMutationVariables>;